import isArray from 'lodash-es/isArray';
import { dash } from 'radash';
import '@nettbureau/theme';
import 'polished';
import { parseTransitionDuration } from '../parsers/transition-duration.js';
import { parseTransitionEasing } from '../parsers/transition-easing.js';

/**
 * Generates CSS for applying transitions to an element's properties based on
 * the motion theme tokens.
 *
 * @param options - Options for the mixin.
 */ function transition(options) {
    const transitions = isArray(options) ? options : [
        options
    ];
    return (theme)=>({
            transition: transitions.map(({ properties, duration = 'fast', easing = 'standard' })=>{
                const durationValue = parseTransitionDuration(theme, duration);
                const easingvalue = parseTransitionEasing(theme, easing);
                return `${properties.map((property)=>`${dash(property)} ${durationValue} ${easingvalue}`).join(',')}`;
            }).join(',')
        });
}

export { transition };
//# sourceMappingURL=transition.js.map
